module.exports = __webpack_public_path__ + "img/icon_map_16.5d6d2ef5.svg";